"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toCustComponents = exports.transformCustoComp = exports.createComponentsTransformation = exports.toCustoTexts = exports.toCustoFns = exports.toCustoHooks = void 0;

var prop_1 = require("../../utils/prop");

var hook_1 = require("../hook");

var texts_1 = require("../texts");

var __1 = require("../..");

var components_1 = require("../components");

var react_1 = __importDefault(require("react"));

var set_1 = require("../../utils/set");

var utils_1 = require("../../utils");

var toCustoFnOrHooks = function toCustoFnOrHooks(type, obj, flag) {
  return prop_1.deepMapObject(obj, function (val) {
    if (val instanceof hook_1.CustoHook) {
      return {
        stop: true,
        newVal: val
      };
    }

    if (typeof val === "function") {
      return {
        stop: true,
        newVal: flag === "functions" ? type === __1.CustoType.component ? hook_1.CustoHook.createComponentFn(val) : type === __1.CustoType.data ? hook_1.CustoHook.createDataFn(val) : type === __1.CustoType.text ? hook_1.CustoHook.createTextFn(val) : hook_1.CustoHook.createFn(val) : type === __1.CustoType.component ? hook_1.CustoHook.createComponentHook(val) : type === __1.CustoType.data ? hook_1.CustoHook.createDataHook(val) : type === __1.CustoType.text ? hook_1.CustoHook.createTextHook(val) : hook_1.CustoHook.createHook(val)
      };
    }

    return {
      stop: false
    };
  });
};

exports.toCustoHooks = function (type, obj) {
  return toCustoFnOrHooks(type, obj, "hooks");
};

exports.toCustoFns = function (type, obj) {
  return toCustoFnOrHooks(type, obj, "functions");
}; ///


exports.toCustoTexts = function (obj) {
  return prop_1.deepMapObject(obj, function (val) {
    if (utils_1.isCustoClass(val)) {
      return {
        stop: true,
        newVal: val
      };
    }

    if (typeof val === "string" || typeof val === "number" || val === null) {
      return {
        stop: true,
        newVal: texts_1.CustoText.create(val)
      };
    }

    return {
      stop: false
    };
  });
}; ///


exports.createComponentsTransformation = function (defaultProps, options) {
  if (options === void 0) {
    options = {};
  }

  return function (obj) {
    return prop_1.deepMapObject(obj, function (val) {
      if (val instanceof __1.CustoComponent) {
        return {
          stop: true,
          newVal: exports.transformCustoComp(val, defaultProps, options)
        };
      } else if (val instanceof hook_1.CustoHook && val.type == __1.CustoType.component) {
        var cloned = val.clone();
        var transformationFn_1 = cloned.transformationFn;

        cloned.transformationFn = function (data) {
          var transformedData = transformationFn_1 ? transformationFn_1(data) : data;
          return exports.transformCustoComp(transformedData, defaultProps, options);
        }; //


        return {
          stop: true,
          newVal: cloned
        };
      } else if (utils_1.isCustoClass(val)) {
        return {
          stop: true,
          newVal: val
        };
      }

      if (isReactComponent(val)) {
        return {
          stop: true,
          newVal: __1.CustoComponent.create(val, defaultProps, options)
        };
      }

      return {
        stop: false
      };
    });
  };
};

exports.transformCustoComp = function (comp, defaultProps, options) {
  var newComp = comp.clone();
  newComp.defaultProps = components_1.mergeValueOrFn(defaultProps, newComp.defaultProps || {}, function (v1, v2) {
    return __assign(__assign({}, v1), v2);
  });
  var keys = Object.keys(options);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var oldVal = newComp[key];

    if (oldVal === undefined) {
      newComp[key] = options[key];
    }
  }

  var iterableValueKeys = ["labels", "stripPropKeys", "additionalMergeFlags", "subtractiveMergeFlags"];

  for (var i = 0; i < iterableValueKeys.length; i++) {
    var key = iterableValueKeys[i];
    if (!options.hasOwnProperty(key)) continue;
    var oldVal = newComp[key];
    if (options[key] === oldVal || !oldVal) continue;
    newComp[key] = mergeIterables(options[key], oldVal);
  }

  return newComp;
};

var mergeIterables = function mergeIterables(a, b) {
  if (a instanceof Set || b instanceof Set) {
    return set_1.unionWith.call(new Set(a), b);
  }

  return __spread(a, b);
};

var isReactComponent = function isReactComponent(e) {
  return typeof e === "function" || e instanceof react_1.default.Component || e instanceof react_1.default.PureComponent || typeof e === "object" && e && e["$$typeof"];
};

exports.toCustComponents = exports.createComponentsTransformation({});